module.exports = __webpack_public_path__ + "static/media/schmidt_reid_erwin.d0de925d.jpg";